export enum GoogleIntegrationSiteStatuses {
  Unknown = 0,
  Pass = 1,
  Fail = 2,
  Unreachable = 3,
  NotConfigured = 4,
}
